import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BookingsService } from 'src/app/core/services/bookings.service';
import { SessionNotesService } from 'src/app/core/services/session-notes.service';
import { SessionNote } from 'src/app/core/models/session-note.model';
import { Booking } from 'src/app/core/models/booking.model';

@Component({
  selector: 'app-write-instructor-notes',
  templateUrl: './write-instructor-notes.component.html',
  styleUrls: ['./write-instructor-notes.component.scss']
})
export class WriteInstructorNotesComponent implements OnInit {

  public Editor;
  notes: string;
  studentName: string
  booking: Booking;
  editorText: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private bookingsService: BookingsService, private parentDilogRef: MatDialogRef<WriteInstructorNotesComponent>) {
    this.booking = this.data.booking;
    this.Editor = ClassicEditor;
  }

  public onChange({ editor }: ChangeEvent) {
    const data = editor.data.get()
    this.notes = data;
  }

  async saveNotes() {
    this.booking.notes = this.notes;
    this.bookingsService.updateBooking(this.booking);
    this.parentDilogRef.close();
  }

  cancel() {
    this.parentDilogRef.close();
  }

  ngOnInit(): void {

    this.editorText = this.data.booking.notes?.length > 0 ? this.data.booking.notes : '';
  }

}
